const normal = {
  color: `alpha`,
  textDecoration: `none`,
  userSelect: `none`,
  ':visited': {
    color: 'alpha'
  },
  ':hover': {
    color: 'alphaDark'
  }
}

export default normal